module.exports = __webpack_public_path__ + "img/leaf_2.1bee4aca.png";